import React, { useEffect, useState, useRef } from 'react'
import Input from '../../components/input/Input';
import ShippingDetails from '../../sharedComponents/ShippingDetails';
import './OrderForm.css'
import { validateNumberInput, numberFields } from '../../utils/formValidations';
import { showsBillUrl, showsTransactionUrl } from '../../utils/websiteLinkFields';
import { toast } from 'react-toastify';
import useManageOrder from '../order/useManageOrder';
import Checkbox from '@mui/material/Checkbox';
import OrderService from '../order/OrderService';

const EditOrder = ({editingOrder, setEditingOrder,refreshPendingOrder, orderGroup, onBeforeSave, onSaved}) => {

  const {updateOrder} = useManageOrder();

  // Track only the fields the admin actually edits, so the save PATCHes just those
  // (plus identifiers) instead of the whole order. Resending the full object is how
  // a stale open form silently overwrites webhook-written fields (e.g. productPayment).
  const dirtyRef = useRef(new Set());
  useEffect(() => {
    // New order selected → start a fresh change set.
    dirtyRef.current = new Set();
  }, [editingOrder?.id]);

  // ส่งตรวจ (anshin appraisal) — checkbox state applied on Update, like every other field.
  const existingAnshinFee = Array.isArray(editingOrder?.extraJpFees)
    ? editingOrder.extraJpFees.find(f => f.type === 'mercari_anshin')
    : null;
  const [sendInspection, setSendInspection] = useState(false);
  const [anshinSuggestion, setAnshinSuggestion] = useState(null);

  useEffect(() => {
    // Sync checkbox with the order's current state each time a new order is picked
    setSendInspection(!!existingAnshinFee);
    setAnshinSuggestion(null);
    const url = (editingOrder?.url || '').trim();
    if (!editingOrder?.id || existingAnshinFee) return; // no lookup needed when already recorded
    if (!/(jp\.mercari\.com|mercari-shops\.com)/i.test(url)) return;
    let cancelled = false;
    OrderService.suggestExtraFees(url)
      .then(res => { if (!cancelled) setAnshinSuggestion(res.data?.suggestions?.[0] || null); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [editingOrder?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const anshinAvailable = !!existingAnshinFee || !!anshinSuggestion;
  const anshinJpy = Number(existingAnshinFee ? existingAnshinFee.amountJpy : anshinSuggestion?.amountJpy) || 0;

  // Apply the checkbox diff against the order's saved state (called from handleUpdate)
  const applyInspectionChange = async () => {
    if (sendInspection && !existingAnshinFee && anshinSuggestion) {
      await OrderService.addExtraFee({
        orderId: editingOrder.id,
        type: anshinSuggestion.type,
        label: anshinSuggestion.label,
        amountJpy: anshinSuggestion.amountJpy,
      });
    } else if (!sendInspection && existingAnshinFee) {
      await OrderService.removeExtraFee({ orderId: editingOrder.id, type: 'mercari_anshin' });
    }
  };

  useEffect(() => {
    let updatedShipDetail;
    if (editingOrder.isCod) {
      updatedShipDetail = 'cod';
    } else if (editingOrder.deliveryFeeJp){
      updatedShipDetail = 'normal';
    } else if (editingOrder.deliveryFeeJp == 0) {
      updatedShipDetail = 'free';
    } else if (editingOrder.deliveryFeeJp == null && editingOrder.smileNameInput) {
      updatedShipDetail = 'unknown';
    }

    if (updatedShipDetail) {
        setEditingOrder(prevOrder => ({
            ...prevOrder,
            shipDetail: updatedShipDetail
        }));
    }
}, [editingOrder.uuid, editingOrder.isCod, setEditingOrder]);


  const handleButtonClick = (type) => {
    console.log(type)
    let newDetail = type;
    let newFee = null;
    
    if (editingOrder.shipDetail === type) {
        newDetail = 'normal';
    }

    if (type === 'free') {
        newFee = '0';
    }

    // Shipping detail drives isCod server-side, so send shipDetail + deliveryFeeJp together.
    dirtyRef.current.add('shipDetail');
    dirtyRef.current.add('deliveryFeeJp');

    setEditingOrder(prevOrder => ({
        ...prevOrder,
        shipDetail: newDetail,
        deliveryFeeJp: newFee
    }));
    console.log(editingOrder)
  };

  const handleOrderChange = (name, value) => {
    //console.log(editingOrder)
    if (numberFields.has(name)) {
			value = validateNumberInput(value, editingOrder[name]);
		}
    dirtyRef.current.add(name);
    setEditingOrder(prevState => ({
      ...prevState,
      [name]: value,
      //keyDataUpdate: true
    }));;
  };

  const handleUpdate = async () => {
		if(editingOrder.deliveryFeeJp == 0 && editingOrder.shipDetail == 'normal'){
			toast.warning('Please select Shipping Detail')
		}else{
      // Bail out if the parent detects the order changed under us (stale form guard).
      if (onBeforeSave) {
        const ok = await onBeforeSave();
        if (!ok) return;
      }

      // Send only the edited fields (+ identifiers) so we never overwrite fields the
      // admin didn't touch — e.g. payment status flipped by a webhook meanwhile.
      const changed = {};
      dirtyRef.current.forEach(key => { changed[key] = editingOrder[key]; });
      const payload = { uuid: editingOrder.uuid, id: editingOrder.id, ...changed };

			const addResult = await updateOrder(payload);
      console.log(addResult)
			if(addResult){
				try {
					await applyInspectionChange();
				} catch (err) {
					toast.error('อัพเดทออเดอร์สำเร็จ แต่บันทึกส่งตรวจไม่สำเร็จ: ' + (err.response?.data?.message || err.message));
				}
				toast.success('Update Order Successfully!!')
        console.log("SUCCEESS")
        await refreshPendingOrder()
        // Re-baseline so a follow-up edit of this same order isn't seen as stale.
        dirtyRef.current = new Set();
        if (onSaved) await onSaved();
			}
		}
  };

  return (
    <div className='px-5 h-full border-l pt-3 block'>
        <div className='text-2xl border-b pb-2'>Edit Order</div>
        <div className='pt-5'></div>
        <div className='mb-3'>
          <Input title={'Smile Name'} name={'smileNameInput'} value={editingOrder?.smileNameInput} onChange={value => handleOrderChange('smileNameInput',value)}/>
        </div>
        <div className='mb-3'>
          <Input title={'Product Rate'} name={'productRate'} value={editingOrder?.productRate} onChange={value => handleOrderChange('productRate',value)}/>
        </div>
        <div className='mb-3'>
          <Input title={'Amount'} name={'amount'} value={editingOrder?.amount} onChange={value => handleOrderChange('amount',value)}/>
        </div>
        <div className='mb-3'>
          <Input 
            title={'Shipping Fee'} 
            name={'deliveryFeeJp'} 
            value={editingOrder?.deliveryFeeJp} 
            textColor={!['normal','free'].includes(editingOrder?.shipDetail) ? 'gray' : 'red'}
					  readonly={editingOrder?.shipDetail !== 'normal'}
            onChange={value => handleOrderChange('deliveryFeeJp',value)}/>
        </div>
        {showsBillUrl(editingOrder?.website) && (
        <div className='mb-3'>
          <Input title={'ลิ้งค์บิล (Rakuten)'} name={'billUrl'} value={editingOrder?.billUrl} onChange={value => handleOrderChange('billUrl',value)}/>
        </div>
        )}
        {showsTransactionUrl(editingOrder?.website) && (
        <div className='mb-3'>
          <Input title={'Transaction Page URL'} name={'transactionPageUrl'} value={editingOrder?.transactionPageUrl} onChange={value => handleOrderChange('transactionPageUrl',value)}/>
        </div>
        )}
        <ShippingDetails order={editingOrder} onButtonClick={handleButtonClick} />
        <div className='flex'>
          <div className="flex items-center">
            <label htmlFor="isCod" className="font-medium leading-6 text-gray-900">
              มัดจำ
            </label>
            <Checkbox
              checked={editingOrder.isDown || false}
              onChange={(e) => handleOrderChange('isDown', e.target.checked)}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            <label htmlFor="jpShipIsDown" className="font-medium leading-6 text-gray-900">
              มัดจำค่าส่ง
            </label>
            <Checkbox
              checked={editingOrder.jpShipIsDown || false}
              onChange={(e) => handleOrderChange('jpShipIsDown', e.target.checked)}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          </div>
          <div className="flex items-center mx-3">
            <label htmlFor="isCod" className="font-medium leading-6 text-gray-900">
              จ่ายบัตรเครดิต
            </label>
            <Checkbox
              checked={editingOrder.isCredit || false}
              onChange={(e) => handleOrderChange('isCredit', e.target.checked)}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          </div>
        </div>
        {anshinAvailable && (
          <div className="flex items-center">
            <label htmlFor="sendInspection" className={`font-medium leading-6 ${sendInspection ? 'text-green-700' : 'text-amber-700'}`}>
              ส่งตรวจ{anshinJpy > 0 ? ` (¥${anshinJpy})` : ' (ฟรี)'}
            </label>
            <Checkbox
              checked={sendInspection}
              onChange={(e) => setSendInspection(e.target.checked)}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          </div>
        )}

        <button 
          className="ml-auto mt-3 rounded-md bg-indigo-600 px-10 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={handleUpdate}
        >
          Update
        </button>
    </div>
  )
}

export default EditOrder